import React from "react";

export default function Error() {
  return <div>Error, page not found</div>;
}
